import script from "./PanelizationPropositionList.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelizationPropositionList.vue?vue&type=script&setup=true&lang=js"

import "./PanelizationPropositionList.vue?vue&type=style&index=0&id=0db6d20e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db6d20e"]])

export default __exports__